class ProjectConstructor {
  constructor() {
    this.projectList = new Map(); //key - project id, value :{ id ,name, .... }
  }

  getSize = () => {
    return this.projectList.size;
  };

  getProjectList = () => {
    return this.projectList;
  }

  getProjectValues = () => {
    let list = [];
    for (let val of this.projectList.values()) {
      list.push(val);
    }
    return list;
  }

  getProject = (id) => {
    return this.projectList.get(id);
  }

  addProject = (id, data) => {
    this.projectList.set(id, data);
  }

  addProjects = (list) => {
    for (let item of list || []) {
      this.projectList.set(item.id, item);
    }
  }

  delProject = (id) => {
    this.projectList.delete(id);
  }

  clearCache = () => {
    this.projectList = new Map();
  }
};

let projectConstructor = new ProjectConstructor();
export default projectConstructor;